import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SearchResult } from 'src/domain/searchResults/searchResult';
import { AuthService } from '../auth.service';
import { GlobalService } from '../global.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  endpoint = this.globalService.endpoint;

  dialogSettings: boolean = false;

  openRecapSettings: boolean;
  recapItems: any[];
  recapItemsSelected: any[] = [];

  dashboardItems: any[];
  dashboardItemsSelected: any[];

  // LOADER
  riparazioniIsLoading: boolean = true;
  daParteIsLoading: boolean = true;
  differitaIsLoading: boolean = true;
  nessunDatoDaMostrare: boolean = false;

  // RIPARAZIONI
  riparazioniTotaliAperte: number = 0;
  riparazioniAttesaRitiro: number = 0;
  riparazioniInRipDaTotGiorni: number = 0;
  riparazioniAggiunteGiorni: number = 0;

  //Per STATO RIPARAZIONE
  ripPresaInConsegna: number = 0;
  ripInRiparazione: number = 0;
  ripResaERiparata: number = 0;
  ripResaMaNonRiparata: number = 0;
  ripStatusChart: any;

  //Per TIPO RIPARAZIONE
  ripTipoNormale: number = 0;
  riptipoPreventivo: number = 0;
  ripTipoUrgente: number = 0;
  ripTipoGaranzia: number = 0;
  ripTipoDaVendita: number = 0;
  ripTipoOmaggio: number = 0;
  ripTipoDelNegozio: number = 0;
  ripTypeChart: any;

  //per TIPO LAVORO
  ripLavoroOrafo: number = 0;
  ripLavoroInfilatura: number = 0;
  ripLavoroRipOrologio: number = 0;
  ripLavoroIncisione: number = 0;
  ripLavoroPulitura: number = 0;
  ripWorkTypeChart: any;

  // DA PARTE
  daParteAperte: number = 0;
  daParteGiorniTrascorsiMedia: number = 0;

  // DIFFERITE
  differiteAperte: number = 0;

  // CLIENTI
  cusBestCustChart: any; 
  
  //VENDITE
  saleTrimetrali: any;
  saleMargini: any;



  constructor(
    private http: HttpClient, 
    private auth: AuthService, 
    private globalService: GlobalService,
  ) {
    
  }

  getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  localStorage.getItem('login_token')
    });
  }

  public showSettingsDialog(target: string) {
    this.dialogSettings = true;
    if (target === 'recap') {
      this.openRecapSettings = true;
    } else {
      this.openRecapSettings = false;
    }
  }

  

  public initDashboard() {
    if (localStorage.getItem('dashboardSave')) {
      this.dashboardItems = JSON.parse(localStorage.getItem('dashboardSave'));
    } else {

    }
    if (localStorage.getItem('dashboardSaveSelected')) {
      this.dashboardItemsSelected = JSON.parse(localStorage.getItem('dashboardSaveSelected'));
    } else {
      this.dashboardItemsSelected = [];
    }
  }

  public saveRecap() {
    localStorage.setItem('recapSave', JSON.stringify(this.recapItems));
    localStorage.setItem('recapSaveSelected', JSON.stringify(this.recapItemsSelected));
  }

  public saveDashboard() {
    localStorage.setItem('dashboardSave', JSON.stringify(this.dashboardItems));
    localStorage.setItem('dashboardSaveSelected', JSON.stringify(this.dashboardItemsSelected));
  }

  

  public initRecap() {
    if (localStorage.getItem('recapSave')) {
      this.recapItems = JSON.parse(localStorage.getItem('recapSave'));
    } else {
      this.recapItems = [];
      this.recapItems.push({id: 1, desc: 'Totali Aperte', cat: 'Riparazioni', value: this.riparazioniTotaliAperte, color: '#7ED5EA'});
      this.recapItems.push({id: 2, desc: 'In Attesa di Ritiro', cat: 'Riparazioni', value: this.riparazioniAttesaRitiro, color: '#7ED5EA'});
      this.recapItems.push({id: 3, desc: 'Aggiunte', cat: 'Riparazioni', value: this.riparazioniAggiunteGiorni, color: '#7ED5EA'});
      this.recapItems.push({id: 4, desc: 'Aperte', cat: 'Differite', value: this.differiteAperte, color: '#63BCE5'});
      this.recapItems.push({id: 5, desc: 'Aperti', cat: 'Oggetti Da Parte', value: this.daParteAperte, color: '#63BCE5'});
      this.recapItems.push({id: 6, desc: 'Media Giorni Trascorsi', cat: 'Oggetti Da Parte', value: this.daParteGiorniTrascorsiMedia, color: '#56B9BD'});
    }
    if (localStorage.getItem('recapSaveSelected')) {
      this.recapItemsSelected = JSON.parse(localStorage.getItem('recapSaveSelected'));
    } else {
      this.recapItemsSelected = [];
    }
  }

  private assegnaRiparazioni(data: any) {
    
    // riparazioni
    this.assegnaValoriRiparazioni(data);

    // da parte
    this.assegnaValoriDaParteDifferite(data);

    this.riparazioniIsLoading = false;
    this.daParteIsLoading = false;
    this.differitaIsLoading = false;
  }

  private assegnaValoriRiparazioni(data: any) {
    this.riparazioniTotaliAperte = data.Result.RiparazioniTotaliAperte;
    this.riparazioniAttesaRitiro = data.Result.RiparazioniInAttesaRitiro;
    this.riparazioniInRipDaTotGiorni = data.Result.RiparazioniInviate;
    this.riparazioniAggiunteGiorni = data.Result.RiparazioniAggiunte;
  }


  private assegnaValoriDaParteDifferite(data: any) {
    this.daParteAperte = data.Result.DaParteTotaliAperti;
    this.daParteGiorniTrascorsiMedia = data.Result.DaParteMediaGiorniTrascorsi;
    this.differiteAperte = data.Result.DifferiteTotaliAperte;
  }

  public getTotali() {
    const url = this.endpoint + 'dashboard/gettotali';
    const params = {
      StoreID: this.globalService.selShop
    }
    return this.http.post<SearchResult>(url, params, {headers: this.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

}
